import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { defineResources } from "./defineResources.ts";

export const AppShellResources = defineResources({
  [LanguageEnum.CS]: {
    toggleNavigationAriaLabel: "Přepnout navigaci",
    settingsAriaLabel: "Nastavení",
  },
  [LanguageEnum.EN]: {
    toggleNavigationAriaLabel: "Toggle navigation",
    settingsAriaLabel: "Settings",
  },
});
